import { render, staticRenderFns } from "./MailTestModal.vue?vue&type=template&id=0b2fda1b&"
import script from "./MailTestModal.vue?vue&type=script&lang=js&"
export * from "./MailTestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\invoiceasy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b2fda1b')) {
      api.createRecord('0b2fda1b', component.options)
    } else {
      api.reload('0b2fda1b', component.options)
    }
    module.hot.accept("./MailTestModal.vue?vue&type=template&id=0b2fda1b&", function () {
      api.rerender('0b2fda1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/MailTestModal.vue"
export default component.exports